import React from 'react'
import './Service.css';

function Service() {
  return (
    <div className='service'>
        <div className='choose-header'>
         <h2>Inpatient and Outpatient Care</h2>
         <p>We provide both inpatient and outpatient services to ensure you receive the care you need, whether it’s a short visit or an extended stay.</p>     
       </div>

       <div className='care'>
          <div className='care-left'>
            <h2>Specialized Medical Departments</h2>
            <p><strong>Cardiology:</strong> Comprehensive heart care, from prevention to advanced treatments.</p>
            <p><strong>Orthopedics:</strong> Expert care for bones, joints, and muscles.</p>
            <p><strong>Pediatrics:</strong> Specialized care for children and adolescents.</p>
            <p><strong>Gynecology:</strong> Women's health services, including maternity care.</p>
            <p><strong>Neurology:</strong> Advanced care for neurological conditions.</p>
          </div>

          <div className='care-right'>
            <img src='https://res.cloudinary.com/dxnukbo0u/image/upload/v1721714658/2148894925_dduzg7.jpg' alt=''></img>
          </div>      
       </div>

       <div className='care' id='care-reverse'>
         <div className='care-right'>
            <img src='https://res.cloudinary.com/dxnukbo0u/image/upload/v1721659884/1360_gan8mu.jpg' alt=''></img>
          </div> 

          <div className='care-left'>
            <h2>Diagnostic Services</h2>
            <p><strong>Imaging:</strong>  MRI, CT scans, X-rays, and ultrasounds.</p>
            <p><strong>Laboratory:</strong>  Blood tests, biopsies, and other lab work.</p>
            <p><strong>Cardiac Diagnostics:</strong> ECG, echocardiograms, and stress tests.</p>
          </div>     
       </div>
     
    </div>
  )
}

export default Service